import config from '../../../../common/utils/constants/config';
import { mapStyleTypes } from '../../../utils/constants/map-styles';
import {
  removeLayersWhenMapReady,
  createGetLayerIdWithPostfix,
  getLayersIdUniquePostfix,
} from '../../../utils/helpers/interactiveLayerStyleUtils';

export const tileset = config.BUILDING_TILESET;
export const sourceId = config.BUILDING_SOURCE_ID;
export const sourceLayer = config.BUILDING_SOURCE_LAYER;

const getLayerId = createGetLayerIdWithPostfix('default_building');
const getHoveredLayerId = createGetLayerIdWithPostfix('hovered_building');
const getSelectedLayerId = createGetLayerIdWithPostfix('selected_building');

const getStreetsBasedStyle = (layersIdPostfix: string) => {
  const layerId = getLayerId(layersIdPostfix);
  const hoveredLayerId = getHoveredLayerId(layersIdPostfix);
  const selectedLayerId = getSelectedLayerId(layersIdPostfix);

  return {
    add: (map) => {
      const style = map.getStyle();

      if (!style.sources[sourceId as string]) {
        map.addSource(sourceId, {
          type: 'vector',
          url: tileset,
        });
      }

      if (!style.layers.some(({ id }) => id === layerId)) {
        map.addLayer({
          id: layerId,
          type: 'fill',
          source: sourceId,
          'source-layer': sourceLayer,
          paint: {
            'fill-color': 'transparent',
          },
        });
      }

      if (!style.layers.some(({ id }) => id === hoveredLayerId)) {
        map.addLayer({
          id: hoveredLayerId,
          type: 'fill',
          source: sourceId,
          'source-layer': sourceLayer,
          paint: {
            'fill-color': '#0028fa',
            'fill-opacity': [
              'case',
              ['boolean', ['feature-state', 'hidden'], false],
              0,
              ['boolean', ['feature-state', 'selected'], false],
              0,
              ['boolean', ['feature-state', 'hover'], false],
              0.1,
              0,
            ],
          },
        });
      }

      if (!style.layers.some(({ id }) => id === selectedLayerId)) {
        map.addLayer({
          id: selectedLayerId,
          type: 'fill',
          source: sourceId,
          'source-layer': sourceLayer,
          paint: {
            'fill-color': '#fa0000',
            'fill-opacity': [
              'case',
              ['boolean', ['feature-state', 'hidden'], false],
              0,
              ['boolean', ['feature-state', 'selected'], false],
              0.3,
              ['boolean', ['feature-state', 'hover'], false],
              0,
              0,
            ],
          },
        });
      }
    },
    remove: (map) =>
      removeLayersWhenMapReady(map, [layerId, hoveredLayerId, selectedLayerId]),
  };
};

const getSatelliteBasedStyle = (layersIdPostfix: string) => {
  const layerId = getLayerId(layersIdPostfix);
  const hoveredLayerId = getHoveredLayerId(layersIdPostfix);
  const selectedLayerId = getSelectedLayerId(layersIdPostfix);
  return {
    add: (map) => {
      const style = map.getStyle();

      if (!style.layers.some(({ id }) => id === layerId)) {
        map.addLayer({
          id: layerId,
          type: 'fill',
          source: sourceId,
          'source-layer': sourceLayer,
          paint: {
            'fill-color': 'transparent',
          },
        });
      }

      if (!style.layers.some(({ id }) => id === hoveredLayerId)) {
        map.addLayer({
          id: hoveredLayerId,
          type: 'fill',
          source: sourceId,
          'source-layer': sourceLayer,
          paint: {
            'fill-color': '#0028fa',
            'fill-opacity': [
              'case',
              ['boolean', ['feature-state', 'hidden'], false],
              0,
              ['boolean', ['feature-state', 'selected'], false],
              0,
              ['boolean', ['feature-state', 'hover'], false],
              0.1,
              0,
            ],
          },
        });
      }

      if (!style.layers.some(({ id }) => id === selectedLayerId)) {
        map.addLayer({
          id: selectedLayerId,
          type: 'fill',
          source: sourceId,
          'source-layer': sourceLayer,
          paint: {
            'fill-color': '#fa0000',
            'fill-opacity': [
              'case',
              ['boolean', ['feature-state', 'hidden'], false],
              0,
              ['boolean', ['feature-state', 'selected'], false],
              0.3,
              ['boolean', ['feature-state', 'hover'], false],
              0,
              0,
            ],
          },
        });
      }
    },
    remove: (map) =>
      removeLayersWhenMapReady(map, [layerId, hoveredLayerId, selectedLayerId]),
  };
};

export const getLayerStyleData = (mapStyleId?: string) => {
  const layersIdPostfix = getLayersIdUniquePostfix(mapStyleId);

  let style: unknown = null;
  switch (mapStyleId) {
    case mapStyleTypes.streets:
      style = getStreetsBasedStyle(layersIdPostfix);
      break;
    case mapStyleTypes.satellite:
    case mapStyleTypes.hybrid:
      style = getSatelliteBasedStyle(layersIdPostfix);
      break;
  }

  return {
    style,
    layerId: getLayerId(layersIdPostfix),
    hoveredLayerId: getHoveredLayerId(layersIdPostfix),
    selectedLayerId: getSelectedLayerId(layersIdPostfix),
  };
};
